export default "__VITE_ASSET__$m2OUDjb__"